<ul class="list-option column-between">
    <li *ngFor="let option of options" class="item-option row-between gap-8 width-100 in-menu-option" (click)="emit(option)">
        {{option.name}}
    </li>
</ul>